import { pairwise, startWith } from 'rxjs';
import { GA_MEASUREMENT_ID } from './envs.js';
import { userStatus$ } from './stores/store-main.js';
function loadGA(id) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.insertBefore(script, document.head.firstChild);
    window.dataLayer = window.dataLayer || [];
}
export function initializeAnalytics() {
    const search = new URLSearchParams(document.location.search);
    if (GA_MEASUREMENT_ID && !search.has('noga')) {
        loadGA(GA_MEASUREMENT_ID);
        sendAnalytics('js', new Date());
        sendAnalytics('config', GA_MEASUREMENT_ID, {
            anonymize_ip: true,
            send_page_view: false,
        });
    }
    userStatus$
        .pipe(startWith(undefined), pairwise())
        .subscribe(([oldStatus, newStatus]) => {
        if (oldStatus === newStatus) {
            return;
        }
        sendAnalytics('config', GA_MEASUREMENT_ID, {
            user_properties: {
                subscription_status: newStatus,
            },
        });
    });
}
export function sendAnalytics(_command, ..._args) {
    if (window.dataLayer) {
        window.dataLayer.push(arguments);
    }
}
//# sourceMappingURL=analytics.js.map